import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {

    const token = localStorage.getItem("authToken");
    const role = localStorage.getItem("currentRole");

    if (!token || !role) {
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default ProtectedRoute;